import {
  CURRENT_USER_CONNECTING,
  CURRENT_USER_DATA,
} from 'store/types';

const INITIALSTATE = {
  timestamp: null,
  loading: null,
  authUser: null,
  isAdministator: false,
  organization: null,
  apikey: null,
};

export default function (state = INITIALSTATE, action) {
  switch (action.type) {
    case CURRENT_USER_CONNECTING:
      return {
        ...Object.assign(state, {
          timestamp: new Date(),
          loading: true,
        })
      };
    case CURRENT_USER_DATA:
      return {
        ...Object.assign(state, {
          timestamp: new Date(),
          loading: false,
          ...action.payload
        })
      };
    default:
      return state;
  }
};
